import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=2ae06347&scoped=true"
import script from "./Modify.ts?vue&type=script&lang=ts&external"
export * from "./Modify.ts?vue&type=script&lang=ts&external"
import style0 from "./Modify.vue?vue&type=style&index=0&id=2ae06347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae06347",
  null
  
)

export default component.exports